// extracted by mini-css-extract-plugin
export default {"values":"b1q3uTpe7r9RYAF0sZ_w","value":"R6w_0rEx7IL_TB1r7vvN","maxValue":"fUld7nqkrLh2aHBwVzqW","minValue":"h9kg3Khl8NSl66rZtINQ","recommendedValue":"zcDur9Nq2j1v9c04xqaa"};